/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListResponse } from '../models/ListResponse';
import type { PublicAttribute } from '../models/PublicAttribute';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PublicAttributeService {

    /**
     * Get a list of `PublicAttribute`s
     * @returns any A list of `PublicAttribute`s.
     * @throws ApiError
     */
    public static listPublicAttributes({
page,
size,
filter,
sort,
}: {
/**
 * Page number
 */
page?: number,
/**
 * Number of items per page
 */
size?: number,
/**
 * A filter to apply to the results. Multiple filters can be applied by using the same parameter name multiple times. String must be URL encoded. String follows the format field,operator,value(s),required. Filters can be applied to associations by using `[associatedModel*].[attribute]` as field. If values is an array, which is allowed for e.g. the operators "in", "notIn" etc, the delimiter "|" must be used. "required" is allowed, if a deep filter (= filter on an association) is set. In this case, only entities that have an associated entity are returned. *model name should be written as in the API Response, meaning with lowercase first letter and if need be in plural. `required` is optional
 */
filter?: string,
/**
 * Sorts the results by the given field and order. The format is field:order. The order can be asc or desc. Multiple fields can be sorted by using a comma separated list.
 */
sort?: string,
}): CancelablePromise<(ListResponse & {
data?: Array<PublicAttribute>;
})> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/public-attributes',
            query: {
                'page': page,
                'size': size,
                'filter': filter,
                'sort': sort,
            },
        });
    }

    /**
     * Create a new `PublicAttribute`
     * @returns any A single `PublicAttribute`.
     * @throws ApiError
     */
    public static createPublicAttribute({
requestBody,
}: {
requestBody: PublicAttribute,
}): CancelablePromise<{
data?: PublicAttribute;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/public-attributes',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get a specific `PublicAttribute`
     * @returns any A single `PublicAttribute`.
     * @throws ApiError
     */
    public static getPublicAttribute({
id,
}: {
/**
 * ID of the `PublicAttribute`
 */
id: string,
}): CancelablePromise<{
data?: PublicAttribute;
}> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/public-attributes/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Update a specific `PublicAttribute`
     * @returns any A single `PublicAttribute`.
     * @throws ApiError
     */
    public static updatePublicAttribute({
id,
requestBody,
}: {
/**
 * ID of the `PublicAttribute`
 */
id: string,
requestBody: PublicAttribute,
}): CancelablePromise<{
data?: PublicAttribute;
}> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/public-attributes/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete a specific `PublicAttribute`
     * @returns void 
     * @throws ApiError
     */
    public static deletePublicAttribute({
id,
}: {
/**
 * ID of the `PublicAttribute`
 */
id: string,
}): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/public-attributes/{id}',
            path: {
                'id': id,
            },
        });
    }

}
